import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Fingerprint = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 30C16.45 30 16 29.55 16 29C16 28.45 16.45 28 17 28C18.65 28 20 26.65 20 25C20 23.35 18.65 22 17 22C15.35 22 14 23.35 14 25C14 25.55 13.55 26 13 26C12.45 26 12 25.55 12 25C12 22.238 14.238 20 17 20C19.762 20 22 22.238 22 25C22 27.762 19.762 30 17 30Z" />
		<path d="M25.8 18.413C25.8 18.401 25.8 18.401 25.8 18.413C23.7 15.6 20.487 14.001 17 14.001C10.937 14.001 6 18.938 6 25.001C6 25.551 6.45 26.001 7 26.001C7.55 26.001 8 25.551 8 25.001C8 20.039 12.037 16.001 17 16.001C19.863 16.001 22.488 17.314 24.2 19.601C24.388 19.839 24.675 19.988 25 19.988C25.55 19.988 26 19.538 26 18.988C26 18.776 25.925 18.575 25.8 18.413Z" />
		<path d="M25.55 10.162C25.425 10.074 22.237 8 17 8C10.662 8 6.463 12.113 6.287 12.287C6.112 12.462 6 12.712 6 13C6 13.55 6.45 14 7 14C7.275 14 7.525 13.887 7.7 13.713C7.737 13.676 11.512 10 17 10C19.4 10 21.3 10.5 22.462 10.912C23.687 11.35 24.387 11.799 24.437 11.824C24.6 11.924 24.787 11.986 24.987 11.986C25.537 11.986 25.987 11.536 25.987 10.986C25.999 10.648 25.824 10.349 25.549 10.161L25.55 10.162Z" />
		<path d="M6 5C6 5.552 5.552 6 5 6C4.448 6 4 5.552 4 5C4 4.448 4.448 4 5 4C5.552 4 6 4.448 6 5Z" />
		<path d="M12 3C12 3.552 11.552 4 11 4C10.448 4 10 3.552 10 3C10 2.448 10.448 2 11 2C11.552 2 12 2.448 12 3Z" />
		<path d="M25.55 4.16202C25.55 4.16202 22.375 1.99902 17 1.99902C16.45 1.99902 16 2.44902 16 2.99902C16 3.54902 16.45 3.99902 17 3.99902C21.625 3.99902 24.45 5.83602 24.45 5.83602C24.613 5.93602 24.8 5.99802 25 5.99802C25.55 5.99802 26 5.54802 26 4.99802C26 4.64802 25.825 4.34802 25.55 4.16002V4.16202Z" />
	</svg>
);

export default Fingerprint;
